import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { PRIVATE_ROUTES } from '../../routes'
import MarketXLayout from './MarketXLayout'
import InspirationGalleryListView from '../inspirationGallery/view/inspiration-gallery-list-view'
import InspirationDetailView from '../inspirationGallery/view/inspiration-detail-view'

const MarketXRouter = () => (
    <Routes>
        <Route element={<MarketXLayout />}>
            <Route
                index
                element={
                    <Navigate
                        to={PRIVATE_ROUTES.inspirationGallery.root}
                        replace
                    />
                }
            />
            <Route
                path="inspiration-gallery"
                element={<InspirationGalleryListView />}
            />
            <Route
                path="inspiration-gallery/:id"
                element={<InspirationDetailView />}
            />
            <Route
                path="*"
                element={
                    <Navigate
                        to={PRIVATE_ROUTES.inspirationGallery.root}
                        replace
                    />
                }
            />
        </Route>
    </Routes>
)

export default MarketXRouter
